import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e04e2ff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]


    
export default /*#__PURE__*/_defineComponent({
  __name: 'RadioElem',
  props: ['data'],
  emits: ['choose'],
  setup(__props, { emit: __emit }) {

    const props = __props
    const emit = __emit
    const choose = (index:number) => {
        emit('choose', index + 1, 1)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.answers, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "radio",
      key: index
    }, [
      _createElementVNode("i", {
        class: _normalizeClass({'selected' : item.isFlag }),
        onClick: ($event: any) => (choose(index))
      }, null, 10, _hoisted_1),
      _createElementVNode("span", null, _toDisplayString(item.title), 1)
    ]))
  }), 128))
}
}

})